<template>
    <div id="debugsawlineerrorspage">
        <ui5-button id="cancel" @click="$router.push('/debugmenu')">
            {{ trans('pages.debug_sawline_errors.back') }}
        </ui5-button>

        <div id="debug-sawline-errors">
            <div
                v-for="(category, categoryKey) in debugData"
                :key="category.title">
                <template v-if="parseInt(categoryKey) == categoryKey">
                    <h2>{{ category.title }}</h2>
                    <pre v-show="category.showQuery">{{ category.query }}</pre>
                    <table border="1">
                        <thead>
                            <tr>
                                <th
                                    v-for="column in category.columns"
                                    :key="column">
                                    {{ column }}
                                </th>
                            </tr>
                        </thead>
                        <tbody
                            v-if="category.data &amp;&amp; category.data.length &gt; 0">
                            <tr v-for="item in category.data" :key="item.ID">
                                <template v-for="column in category.columns">
                                    <td v-if="column == 'producttype'">
                                        {{
                                            debugData.productTypeNames[
                                                item[column]
                                                ].externalName
                                        }}
                                        (#{{
                                            debugData.productTypeNames[
                                                item[column]
                                                ].ID
                                        }})
                                    </td>
                                    <td v-else="">
                                        {{ item[column] }}
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                        <tbody v-else="">
                            <tr>
                                <td
                                    :colspan="
                                        category.columns
                                            ? category.columns.length
                                            : 0
                                    "
                                    style="color: green; text-align: center">
                                    {{ trans('pages.debug_sawline_errors.everything_ok') }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import sawlineApi from '../api/sawline';
import sawline from '../api/sawline';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    data() {
        return {
            debugData: null,
        };
    },
    mounted() {
        sawline.fetchErrorDebugData().then((request) => {
            const data = request.data.data;
            for (const key in data) {
                if (parseInt(key) == key && data.hasOwnProperty(key)) {
                    data[key].showQuery = false;
                }
            }
            this.debugData = data;
        });
    },
};
</script>
